module.exports = __webpack_public_path__ + "static/media/warehouse-2.5763eb11.svg";